import { Component, OnInit, Input, ViewChild, ViewContainerRef, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormFieldInputComponent } from '../form-field-input/form-field-input.component';
import { FormFieldAutoCompleteComponent } from '../form-field-autocomplete/form-field-autocomplete.component';
import { FormFieldDatePickerComponent } from '../form-field-datepicker/form-field-datepicker.component';
import { FormFieldDropDownComponent } from '../form-field-dropdown/form-field-dropdown.component';
import { FormFieldLocationComponent } from '../form-field-location/form-field-location.component';
import { FormFieldTableComponent } from '../form-field-table/form-field-table.component';
import { typeDHLFormControls } from '../../models/dhl-form-shared-types';
import { FormSearchBoxComponent } from '../form-search-box/form-search-box.component';
import { FormTableListComponent } from '../form-table-list/form-table-list.component';
import { FormFieldHiddenComponent } from '../form-field-hidden/form-field-hidden.component';
import { FormFieldCardComponent } from '../form-field-card/form-field-card.component';
import { FormFieldSlideToggleComponent } from '../form-field-slide-toggle/form-field-slide-toggle.component';
import { FormFieldFilterComponent } from '../form-field-filter/form-field-filter.component';
import { FormFieldButtonComponent } from '../form-field-button/form-field-button.component';
import { FormFieldButtonToggleComponent } from '../form-field-button-toggle/form-field-button-toggle.component';
import { FormFieldWrapperComponent } from '../form-field-wrapper/form-field-wrapper.component';
import { FormFieldChipsAutocompleteComponent } from '../form-field-chips-autocomplete/form-field-chips-autocomplete.component';
import { FormFieldFileUploadComponent } from '../form-field-file-upload/form-field-file-upload.component';
import { FormFieldFileDownloadComponent } from '../form-field-file-download/form-field-file-download.component';
import { AppService } from 'src/app/app.service';
import { FormTableComponent } from '../form-table/form-table.component';
import { StepperContentComponent } from 'src/app/shared/common/stepper-content/stepper-content.component';
import { FormFieldInputV2Component } from '../../components-v2/form-field-input-v2/form-field-input-v2.component';
import { FormFieldToggleSwitchV2Component } from '../../components-v2/form-field-toggle-switch-v2/form-field-toggle-switch-v2.component';
import { FormFieldSpaceholderV2Component } from '../../components-v2/form-field-spaceholder-v2/form-field-spaceholder-v2.component';
import { FormFieldTextareaV2Component } from '../../components-v2/form-field-textarea-v2/form-field-textarea-v2.component';
import { SearchBoxV2Component } from 'src/app/shared/common/search-box-v2/search-box-v2.component';
import { GenericTableV2Component } from 'src/app/shared/common/generic-table-v2/generic-table-v2.component';
import { FormFieldDropdownMultiChoiceV2Component } from '../../components-v2/form-field-dropdown-multi-choice-v2/form-field-dropdown-multi-choice-v2.component';
import { FormFieldDropdownMultiOptionIconV2Component } from '../../components-v2/form-field-dropdown-multi-option-icon-v2/form-field-dropdown-multi-option-icon-v2.component';
import { GenericFilterV2Component } from 'src/app/shared/common/generic-filter-v2/generic-filter-v2.component';
import { GenericFormFilterV2Component } from 'src/app/shared/common/generic-form-filter-v2/generic-form-filter-v2.component';
import { ProgressIndicatorV2Component } from 'src/app/shared/common/progress-indicator-v2/progress-indicator-v2.component';
import { FormFieldDropdownDefaultV2Component } from '../../components-v2/form-field-dropdown-default-v2/form-field-dropdown-default-v2.component';
import { FormFieldDatepickerV2Component } from '../../components-v2/form-field-datepicker-v2/form-field-datepicker-v2.component';
import { FormFieldGenericV2Component } from '../../components-v2/form-field-generic-v2/form-field-generic-v2.component';
import { DatepickerFilterV2Component } from 'src/app/shared/common/datepicker-filter-v2/datepicker-filter-v2.component';
import { FormFieldTableV2Component } from '../../components-v2/form-field-table-v2/form-field-table-v2.component';
import { FormFieldLocationV2Component } from '../../components-v2/form-field-location-v2/form-field-location-v2.component';
import { FormFieldAutocompleteV2Component } from '../../components-v2/form-field-autocomplete-v2/form-field-autocomplete-v2.component';
import { FormFieldAutoPoItemcompleteV2Component } from '../../components-v2/form-field-po-item-autocomplete-v2/form-field-po-item-autocomplete-v2.component';
import { GenericAccordionV2Component } from 'src/app/shared/common/generic-accordion-v2/generic-accordion-v2.component';
import { GenericAccordionGroupV2Component } from 'src/app/shared/common/generic-accordion-group-v2/generic-accordion-group-v2.component';
import { FormFieldLocationAutocompleteV2Component } from '../../components-v2/form-field-location-autocomplete-v2/form-field-location-autocomplete-v2.component'
import { FormFieldOrderLineAutocompleteComponent } from '../../components-v2/form-field-order-line-autocomplete-v2/form-field-order-line-autocomplete-v2.component';
import { GenericFormFieldGroupV2Component } from 'src/app/shared/common/generic-form-field-group-v2/generic-form-field-group-v2.component';
import { FormFieldReadonlyV2Component } from '../../components-v2/form-field-readonly-v2/form-field-readonly-v2.component';
import { FormFieldGenericAutocompleteV2Component } from '../../components-v2/form-field-generic-autocomplete-v2/form-field-generic-autocomplete-v2.component';
import { FormSectionV2Component } from '../../components-v2/form-section-v2/form-section-v2.component';
import {OverviewV2Component} from 'src/app/shared/common/overview-v2/overview-v2.component';
import { FormFieldDropdownSimpleV2Component } from '../../components-v2/form-field-dropdown-simple-v2/form-field-dropdown-simple-v2.component';
import { FormFieldCheckboxV2Component } from './../../components-v2/form-field-checkbox-v2/form-field-checkbox-v2.component';
import { FormFieldDropdownMultiselectV2Component } from '../../components-v2/form-field-dropdown-multiselect-v2/form-field-dropdown-multiselect-v2.component';
import { GenericNotesV2Component } from 'src/app/shared/dhl-form/components-v2/generic-notes-v2/generic-notes-v2.component';
import { FormFieldRadioButtonV2Component } from '../../components-v2/form-field-radio-button-v2/form-field-radio-button-v2.component'
import { FormFieldNumberV2Component } from '../../components-v2/form-field-number-v2/form-field-number-v2.component'
import { WeeklyOperationalHoursV2Component } from '../../components-v2/weekly-operational-hours-v2/weekly-operational-hours-v2.component';
import { GenericTabsV2Component } from '../../components-v2/generic-tabs-v2/generic-tabs-v2.component';
import { ShipmentHistoryV2Component } from 'src/app/shared/common/shipment-history-v2/shipment-history-v2.component';
import { FormFieldToggleGroupV2Component } from '../../components-v2/form-field-toggle-group-v2/form-field-toggle-group-v2.component';
import { GenericFormFilterV3Component } from 'src/app/shared/common/generic-form-filter-v3/generic-form-filter-v3.component';
import { FormFieldTextComponent } from '../../components-v2/form-field-text/form-field-text.component';
import { FormFieldDaterangepickerV2Component } from '../../components-v2/form-field-daterangepicker-v2/form-field-daterangepicker-v2.component';
import { GenericNotesV3Component } from '../../components-v2/generic-notes-v3/generic-notes-v3.component';

type FormComponents =
  FormFieldInputComponent |
  FormFieldAutoCompleteComponent |
  FormFieldDatePickerComponent |
  FormFieldDropDownComponent |
  FormFieldLocationComponent |
  FormFieldTableComponent |
  FormFieldHiddenComponent |
  FormSearchBoxComponent |
  FormFieldCardComponent |
  FormFieldSlideToggleComponent |
  FormFieldFileUploadComponent |
  FormFieldTableV2Component |
  FormFieldLocationV2Component |
  FormFieldLocationAutocompleteV2Component |
  FormFieldAutocompleteV2Component |
  FormFieldAutoPoItemcompleteV2Component |
  FormFieldGenericAutocompleteV2Component |
  OverviewV2Component |
  FormFieldCheckboxV2Component |
  GenericNotesV2Component |
  GenericTabsV2Component |
  ShipmentHistoryV2Component|
  GenericNotesV3Component|
  WeeklyOperationalHoursV2Component;
@Component({
    selector: 'app-form-field',
    templateUrl: './form-field.component.html',
    styleUrls: ['./form-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldComponent implements OnInit {
  @Input() configData: typeDHLFormControls;
  @Input() frmGroup: UntypedFormGroup;
  @Input() screenVersion: any;

  @ViewChild('controlPlaceHolder', { read: ViewContainerRef, static: true }) controlPlaceHolder: ViewContainerRef;
  // Angular 22 removed ComponentFactoryResolver; ViewContainerRef.createComponent() now accepts the component class directly.
  private componentFactoryResolver = { resolveComponentFactory: (component: any) => component };

  constructor(private appService: AppService) { }

  loadComponent() {
    let componentFactory = null;

    this.controlPlaceHolder.clear();
    switch (this.configData.component) {
      case 'INPUT':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldInputComponent);
        break;
      case 'AUTOCOMPLETE':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldAutoCompleteComponent);
        break;
      case 'DATEPICKER':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldDatePickerComponent);
        break;
      case 'DROPDOWN':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldDropDownComponent);
        break;
      case 'LOCATION':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldLocationComponent);
        break;
      case 'TABLE':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldTableComponent);
        break;
      case 'SEARCH':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormSearchBoxComponent);
        break;
      case 'TABLELIST':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormTableListComponent);
        break;
      case 'FILTER':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldFilterComponent);
        break;
      case 'HIDDEN':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldHiddenComponent);
        break;
      case 'CARD':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldCardComponent);
        break;
      case 'SLIDETOGGLE':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldSlideToggleComponent);
        break;
        case 'BUTTON':
          componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldButtonComponent);
          break;
      case 'BUTTONTOGGLE':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldButtonToggleComponent);
        break;
      case 'WRAPPER':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldWrapperComponent);
        break;
      case 'CHIPSAUTOCOMPLETE':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldChipsAutocompleteComponent);
        break;
      case 'FILEUPLOAD':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldFileUploadComponent);
        break;
      case 'FILEDOWNLOAD':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldFileDownloadComponent);
        break;
      case 'FORMTABLE':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormTableComponent);
        break;
      case 'INPUT_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldInputV2Component);
        break;
      case 'TOGGLESWITCH_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldToggleSwitchV2Component);
        break;
      case 'SPACEHOLDER_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldSpaceholderV2Component);
        break;
      case 'TEXTAREA_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldTextareaV2Component);
        break;
      case 'STEPPER':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(StepperContentComponent);
        break;
      case 'SEARCHBOX_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(SearchBoxV2Component);
        break;
      case 'ORDERSTABLE_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(GenericTableV2Component);
        break;
      case 'DROPDOWN_MULTICHOICE_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldDropdownMultiChoiceV2Component);
        break;
      case 'DROPDOWN_MULTIOPTION_ICON_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldDropdownMultiOptionIconV2Component);
        break;
      case 'DROPDOWN_DEFAULT_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldDropdownDefaultV2Component);
        break;
      case 'FILTER_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(GenericFilterV2Component);
        break;
      case 'FORM_FILTER_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(GenericFormFilterV2Component);
        break;
      case 'FORM_FILTER_V3':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(GenericFormFilterV3Component);
        break;
      case 'PROGRESS_INDICATOR_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(ProgressIndicatorV2Component);
        break;
      case 'DATEPICKER_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldDatepickerV2Component);
        break;
      case 'DATERANGEPICKER_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldDaterangepickerV2Component);
        break;
      case 'GENERIC_FIELD_V2':
        // will move it to default
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldGenericV2Component);
        break;
      case 'TABLE_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldTableV2Component);
        break;
      case 'LOCATION_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldLocationV2Component);
        break;
      case 'LOCATION_AUTOCOMPLETE_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldLocationAutocompleteV2Component);
        break;
      case 'AUTOCOMPLETE_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldAutocompleteV2Component);
        break;
      case 'PO_ITEM_AUTOCOMPLETE_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldAutoPoItemcompleteV2Component);
        break;
      case 'ACCORDION_GROUP_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(GenericAccordionGroupV2Component);
        break;
      case 'ACCORDION_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(GenericAccordionV2Component);
        break;
      case 'FORM_FIELD_GROUP_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(GenericFormFieldGroupV2Component);
        break;
      case 'ORDER_ITEM_AUTOCOMPLETE_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldOrderLineAutocompleteComponent);
        break;
      case 'FORM-FIELD-READONLY_V2':
          componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldReadonlyV2Component);
          break;
      case 'GENERIC_AUTOCOMPLETE_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldGenericAutocompleteV2Component);
        break;
      case 'NOTES_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(GenericNotesV2Component);
        break;
      case 'NOTES_V3':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(GenericNotesV3Component);
        break;
      case 'FORM_SECTION_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormSectionV2Component);
        break;

      case 'OVERVIEW_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(OverviewV2Component);
        break;

      case 'CHECKBOX_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldCheckboxV2Component);
        break;

      case 'DROPDOWN_SIMPLE_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldDropdownSimpleV2Component);
        break;

      case 'DROPDOWN_MULTISELECT_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldDropdownMultiselectV2Component);
        break;
      case 'WEEKLY_OPERATIONAL_HOURS':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(WeeklyOperationalHoursV2Component);
        break;      
      case 'NUMBERBOX_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldNumberV2Component);
        break; 
      case 'RADIOBUTTON_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldRadioButtonV2Component);
        break;
      case 'GENERIC_TABS':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(GenericTabsV2Component);
        break; 
      case 'TOGGLEGROUP_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldToggleGroupV2Component);
        break;         
      case 'TEXT':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldTextComponent);
        break;
      case 'SHIPMENT_HISTORY_V2':
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(ShipmentHistoryV2Component);
        break;
      default:
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormFieldInputComponent);
    }
    const componentRef = this.controlPlaceHolder.createComponent(componentFactory);
    const componentInstance = componentRef.instance as FormComponents;
    if(this.screenVersion) this.configData['screenVersion']=this.screenVersion;
    componentInstance.configData = this.configData;
    componentInstance.frmGroup = this.frmGroup;
    this.appService._components[this.configData.name] = componentInstance;

    //Exclude values from copy order
    if(this.configData['copyPasteExclude'] && this.frmGroup.get(this.configData.name)?.value){
      this.frmGroup.get(this.configData.name).setValue("");
    }
  }

  ngOnInit() {
    this.loadComponent();
  }
}
